import { client } from "./client";
import interceptors from "./interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getStock(params) {
	return client.get("api/product-stock/data", {
		params: params,
	});
}

function getStockAll(params) {
	return client.get("api/product-stock/all", {
		params: params,
	});
}

function getStockLog(params) {
	return client.get("api/product-stock-log/data", {
		params: params,
	});
}

function getStockLogAll(params) {
	return client.get("api/product-stock-log/all", {
		params: params,
	});
}

function exportStock(params) {
	return client.get("api/product-stock/export", {
		params: params,
	});
}

function exportStockAll(params) {
	return client.get("api/product-stock/export-all", {
		params: params,
	});
}

function exportStockLog(params) {
	return client.get("api/product-stock-log/export", {
		params: params,
	});
}

function exportStockLogAll(params) {
	return client.get("api/product-stock-log/export-all", {
		params: params,
	});
}

export default {
	getStock,
	getStockAll,
	getStockLog,
	getStockLogAll,
	exportStock,
	exportStockAll,
	exportStockLog,
	exportStockLogAll,
}